import { Component } from '@angular/core';
import { HisAuthService } from 'hisng';

@Component( {
    templateUrl: './businesstripapplication-search.component.html'
} )
export class BusinesstripApplicationSearchComponent {
    readonly SEARCH_CONFIG_PROJECT = 'rm/erp/businesstripapplication/searchBusinesstripApplication.xml';

    constructor( public auth: HisAuthService ) { }
}
